import React, { Component } from 'react';
import { message } from 'antd';
import _ from 'lodash';

import { graphql, withApollo, compose } from 'react-apollo';

import FormOtrosCertificacionesTraspaso from './OtroCertificacionesTraspaso';
import Loading from '../../common/Loading';
import { errorService } from '../../../graphql/utils/utils';
import crearCertificacionTraspaso from '../../../graphql/mutations/rrhh/crearCertificacionTraspaso.graphql';
import subirResolucionPDF from '../../../graphql/mutations/rrhh/subirResolucionPDF.graphql';

@compose(
  graphql(crearCertificacionTraspaso, {
    name: 'crearCertificacionTraspaso',
  }),
  graphql(subirResolucionPDF, {
    name: 'subirResolucionPDF',
  })
)

class OtraCertificacionesTraspasoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      certificacionTraspaso: {
        idInteresado: '',
        idOrganismoOrigen: '',
        idOrganismoDestino: '',
        fechaInicio: null,
        fechaFin: null,
        tipoCertificacionTraspaso: '',
        normativa: '',
      },
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onSubmit(certificacionTraspaso) {
    this.setState({ 
      loading: true,
      certificacionTraspaso 
    });

    // Prepare data for mutation
    const variables = {
      certificacionTraspaso: {
        idTraspaso: certificacionTraspaso.idTraspaso,
        idReemplazante: certificacionTraspaso.idInteresado,
        cargo: certificacionTraspaso.cargo || '',
        idOrigen: certificacionTraspaso.idOrganismoOrigen,
        idDestino: certificacionTraspaso.idOrganismoDestino,
        fechaDesde: certificacionTraspaso.fechaInico,
        fechaHasta: certificacionTraspaso.fechaFin,
        normativa: certificacionTraspaso.normativa,
        pagoViaticos: certificacionTraspaso.pagoViaticos || false,
        observacionCarga: certificacionTraspaso.observacionCarga || '',
        numeroTraspaso: certificacionTraspaso.numeroTraspaso || 0,
        tipoCertificacionTraspaso: certificacionTraspaso.tipoCertificacionTraspaso,
      }
    };

    console.log('Variables para crear la certificación de traspaso:', variables);

    // Create the certificacion traspaso
    this.props.crearCertificacionTraspaso({
      variables: variables,
    })
      .then(res => {
        let idCertificacionTraspaso = res.data.crearCertificacionTraspaso._id;
        this.setState({
          loading: false,
        });
        message.success('Certificación de traspaso creada exitosamente');

        // Upload the PDF file
        if (certificacionTraspaso.resolucion) {
          this.props.subirResolucionPDF({
            variables: {
                resolucion: { idCertificacion: idCertificacionTraspaso },
                archivo: certificacionTraspaso.resolucion,
            },
          })
            .then(uploadRes => {
              const resolucionId = uploadRes.data.subirResolucionPDF._id;
              console.log('Resolución subida exitosamente:', resolucionId);
              this.props.history.push('/rrhh/certificacionesTraspaso');
            })
            .catch(error => {
              console.log('Error al subir la resolución');
              console.log(error);
              message.error('Error al subir la resolución');
            });
        } else {
          this.props.history.push('/rrhh/certificacionesTraspaso');
        }
      })
      .catch(error => {
        console.log('Error al crear la certificación de traspaso');
        console.log(error);
        errorService(error, variables);
        this.setState({
          loading: false,
        });
        message.error('Error al crear la certificación de traspaso');
      });
  }

  onCancel() {
    this.props.history.goBack();
  }

  render() {
    const { certificacionTraspaso, loading } = this.state;

    if (loading) {
      return <Loading />;
    }

    return (
      <div>
        <FormOtrosCertificacionesTraspaso
          datos={certificacionTraspaso}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
        />
      </div>
    );
  }
}

export default graphql(crearCertificacionTraspaso)(OtraCertificacionesTraspasoContainer);